import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { currencyShape } from 'Constants/PropTypes';
import { Labels } from 'Helpers';
import Icon from 'Components/Icon';

class CurrencySelector extends PureComponent {
    constructor() {
        super();

        this.state = { isOpen: false };
        this.optionsRef = React.createRef();
        this.triggerRef = React.createRef();

        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * The component receives information about the clicks and if it was outside of the
     * OccupancySelector or in the trigger then the selector is closed in case it is open
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }

    onChange(newCurrency) {
        const { currentCurrency, defaultCurrency, availableCurrencies, onChangeCurrency } = this.props;

        if (newCurrency !== currentCurrency.code) {
            const currency = newCurrency === defaultCurrency.code
                ? defaultCurrency
                : Object.assign({}, { code: newCurrency }, availableCurrencies[newCurrency]);

            onChangeCurrency(currency);
        }

        this.setState({ isOpen: false });
    }

    /**
     * The method reacts to the caller by considering whether the caller is inside the component
     */
    handleClick(e) {
        const { isOpen } = this.state;
        const [ options, trigger ] = [ this.optionsRef && this.optionsRef.current, this.triggerRef && this.triggerRef.current ];

        if (!isOpen && trigger.contains(e.target)) {
            this.setState({ isOpen: true });
        } else if (isOpen && (trigger.contains(e.target) || !options.contains(e.target))) {
            this.setState({ isOpen: false });
        }
    }

    render() {
        const { defaultCurrency, availableCurrencies, currentCurrency, hidden, displaySymbol } = this.props;
        const { isOpen } = this.state;

        const currencies = Labels.getCurrencies();
        const selectedCurrency = Object.keys(availableCurrencies).find(k => k === defaultCurrency.code);
        const currencyOptions = [];

        const defaultCurrencyOption = {
            key         : defaultCurrency.code,
            value       : defaultCurrency.code,
            text        : currencies[`currency_${defaultCurrency.code}`],
            description : defaultCurrency.code,
            onClick     : () => this.onChange(defaultCurrency.code),
            className   : (defaultCurrency.code === currentCurrency.code) ? 'kbe-active' : '',
            symbol      : defaultCurrency.symbol,
        };

        Object.keys(availableCurrencies).forEach((currencyCode) => {
            if (currencyCode !== selectedCurrency) {
                currencyOptions.push({
                    key         : currencyCode,
                    value       : currencyCode,
                    text        : currencies[`currency_${currencyCode}`],
                    description : currencyCode,
                    onClick     : () => this.onChange(currencyCode),
                    className   : (currencyCode === currentCurrency.code) ? 'kbe-active' : '',
                    symbol      : availableCurrencies[currencyCode].symbol,
                });
            }
        });

        return (
            <div className={`kbe-dropdown kbe-dropdown-right kbe-currency-dropdown ${hidden ? 'kbe-hidden' : ''}`}>
                <div className={`kbe-flex kbe-flex-middle kbe-dropdown-click ${isOpen ? 'kbe-active' : ''}`} ref={this.triggerRef}>
                    <span>{!displaySymbol ? currentCurrency.code : currentCurrency.symbol}</span>
                    <Icon name="CaretDown" className="kbe-margin-left-small" fill="rgba(255, 255, 255, .9)" size="10" />
                </div>
                { isOpen ? <div className="kbe-dropdown-menu" ref={this.optionsRef}>
                    <ul>
                        <li {...defaultCurrencyOption}>{defaultCurrencyOption.text} ({defaultCurrencyOption.symbol})</li>
                        {currencyOptions.length > 0 && <li className="kbe-divider" />}
                        {currencyOptions.map(option => <li key={option.key} {...option}>{option.text} ({option.symbol})</li>)}
                    </ul>
                </div> : null}
            </div>
        );
    }
}

CurrencySelector.defaultProps = { hidden: false };

CurrencySelector.propTypes = {
    displaySymbol       : PropTypes.bool.isRequired,
    defaultCurrency     : PropTypes.shape(currencyShape).isRequired,
    currentCurrency     : PropTypes.shape(currencyShape).isRequired,
    availableCurrencies : PropTypes.objectOf(PropTypes.shape(currencyShape).isRequired).isRequired,
    onChangeCurrency    : PropTypes.func.isRequired,
    hidden              : PropTypes.bool,
};

export default CurrencySelector;
